/**
 * Search page
 * These functions will eventually be loaded conditionally on the search page
 * when all search related functionality is ported over to the new build.
 */
import { toggle } from '../utils';
import parseSearchFormData from './parseSearchFormData';

document.addEventListener('DOMContentLoaded', () => {
  const $form = jQuery('form.site-search-form');
  const initData = parseSearchFormData($form);

  // Initialize the datepicker library.
  jQuery('.datepicker').datepicker({ format: 'yyyy-mm-dd' });

  // Initialize date interval control display state from current values.
  if (initData.date_start || initData.date_end) {
    $form.find('select[name="date_interval"]').val('custom');
  } else {
    $form.find('.date-custom').hide();
  }

  const groups = $form.find('.form-group');
  groups.each((__, element) => {
    const inputs = jQuery(element).find('.checkbox');
    if (5 < inputs.length) {
      const viewMoreButton = jQuery(
        '<button type="button" class="view-more-button">View More</button>'
      ).click((event) => {
        jQuery(element).toggleClass('collapsed');
        const text = jQuery(event.target).text();
        jQuery(event.target).text(
          'View More' === text ? 'View Less' : 'View More'
        );
      });
      jQuery(element).append(viewMoreButton);
    }
  });

  // Bind to form control changes and submit the form when appropriate.
  $form.find('input,checkbox,select').on('change', function bindChangeSubmit() {
    if ('date_interval' === this.name) {
      // For date interval, show/hide controls or trigger search.
      if ('custom' === jQuery(this).val()) {
        jQuery('form.site-search-form .date-custom').slideDown();
      } else {
        jQuery('form.site-search-form .date-custom').slideUp();
        $form.trigger('submit');
      }
    } else {
      $form.trigger('submit');
    }
  });

  // Intercept search form submission and parse form data into a URL.
  $form.on('submit', function parseFormDataToUrl(e) {
    const data = parseSearchFormData(jQuery(this));

    let url = '/';

    e.preventDefault();

    if (data.category_name && '' !== data.category_name) {
      url += `${data.category_name}/`;
    }

    url += 'search/';

    if (data.s) {
      url += `${data.s.replace(/ /g, '+')}/`;
    }

    if (data.post_types.length) {
      // Check if one of the items is NOT empty
      const hasEmpty = - 1 !== data.post_types.indexOf('');

      if (!hasEmpty) {
        url += `type/${data.post_types.join('+')}/`;
      }
    }

    if (data.date_interval && '' !== data.date_interval) {
      if ('custom' !== data.date_interval) {
        url += `last/${data.date_interval}/`;
      } else {
        if (data.date_start) {
          url += `from/${data.date_start}/`;
        }

        if (data.date_end) {
          url += `to/${data.date_end}/`;
        }
      }
    }

    if (data.s && data.orderby && 'date' === data.orderby) {
      url += `?orderby=${data.orderby}`;
    }

    document.location.href = url;
  });

  // toggle the search filter
  toggle('.filters-heading', '.section-form', 'hidden-xs');
});
